import {
  AGENT_AUTH_TOKEN_KEY,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_ERROR,
} from '@/store/types'

import axios from '@/store/axios'

const state = {
  token: null,
  isLoading: false,
  error: null,
}

const initToken = localStorage.getItem(AGENT_AUTH_TOKEN_KEY) || ''

if (initToken) {
  state.token = initToken
}

const getters = {
  getCurrentAccessToken: (state) => (state.token ? state.token.access : null),
  isAuthenticated: (state) => (state.token ? !!state.token : false),
  isAuthLoading: (state) => state.isLoading,
  getAuthError: (state) => state.error,
}

const actions = {
  [AUTH_LOGIN]: ({ commit, state }, { username, password }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)

      axios
        .post(`/api/v1a/agent_users/login/`, { username, password })
        .then((resp) => {
          commit(AUTH_SUCCESS, { token: resp.data.token })
          resolve(resp)
        })
        .catch((error) => {
          commit(AUTH_ERROR, { error })
          reject(error)
        })
    })
  },
  // Not using arrow function for correct "this" context
  [AUTH_LOGOUT]: function ({ commit }) {
    const that = this
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/v1a/agent_users/logout/`)
        .then((resp) => {
          that.reset()

          commit(AUTH_SUCCESS, { logout: true })
          resolve(resp)
        })
        .catch((error) => {
          commit(AUTH_ERROR, { error })
          reject(error)
        })
    })
  },
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.isLoading = true
  },
  [AUTH_SUCCESS]: (state, { token, logout }) => {
    state.isLoading = false

    if (token) {
      state.token = token
      localStorage.setItem(AGENT_AUTH_TOKEN_KEY, token)
    }
    if (logout) {
      state.token = null
      localStorage.removeItem(AGENT_AUTH_TOKEN_KEY)
    }
  },
  [AUTH_ERROR]: (state, { error }) => {
    state.isLoading = false

    if (error) {
      state.error = error
    }

    state.token = null
    localStorage.removeItem(AGENT_AUTH_TOKEN_KEY)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
